<template>
  <div ref="tab" v-if="propList.length > 0" class="c-tab relative overflow-x-auto flex w-full max-w-full border-b">
    <router-link
      v-for="{text, selected, value} in propList"
      :key="value"
      :class="selected"
      :data-value="value"
      :to="value"
      class="c-tab__item a-static relative px-2 py-4 font-subtitle2 whitespace-nowrap hover:text-primary-medium"
    >
      {{ text }}
    </router-link>
  </div>
</template>

<script>
import { props } from './props'
import { ref } from 'vue'
import useList from '@/uses/useList'
import useIndicator from './useIndicator'

export default {
  name: 'CTab',
  props,
  setup (props) {
    const tab = ref(undefined)
    const propSelected = useIndicator(tab, props)
    const propList = useList(props, propSelected)

    return {
      tab,
      propSelected,
      propList
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
